var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _c(
          "div",
          {
            staticClass: "breadcrumbs ace-save-state",
            attrs: { id: "breadcrumbs" }
          },
          [
            _c(
              "ul",
              { staticClass: "breadcrumb" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  { attrs: { tag: "li", to: { name: "gates" } } },
                  [_c("a", [_vm._v("ゲート一覧")])]
                ),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [_vm._v("新規ゲート登録")])
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content detail-gate-edit" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.message_success
              ? _c("div", { staticClass: "alert alert-success" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_success) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.message_error
              ? _c("div", { staticClass: "alert alert-danger" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.message_error) + "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "form",
                  { staticClass: "form-horizontal", attrs: { role: "form" } },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "profile-user-info profile-user-info-striped"
                            },
                            [
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("製品ID")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.gateInfor.gateModelId))
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("製品名")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "product_error" }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.gateModelId,
                                            expression: "gateInfor.gateModelId"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "productname",
                                          "data-placeholder": "製品名選択"
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.gateInfor,
                                                "gateModelId",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function($event) {
                                              _vm.getGateModelInforWithGateModeId(
                                                _vm.gateInfor.gateModelId
                                              )
                                            }
                                          ]
                                        }
                                      },
                                      _vm._l(_vm.listGateModel, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "option",
                                          {
                                            key: index,
                                            domProps: {
                                              value: item.gateModelId
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.gateModelName) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("型番")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.gateInfor.gateModelCode)
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("アイコンタイプ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.gateInfor.iconType,
                                            expression: "gateInfor.iconType"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "iconType",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.listIconType, function(item) {
                                        return _c(
                                          "option",
                                          {
                                            key: item.value,
                                            domProps: { value: item.value }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(item.text) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      })
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.gateInfor.customizable &&
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ターゲット動作設定Time")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.controlTime,
                                                expression:
                                                  "gateInfor.controlTime"
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              max: "10000"
                                            },
                                            domProps: {
                                              value: _vm.gateInfor.controlTime
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.gateInfor,
                                                  "controlTime",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ゲート名")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "gate_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.gateName,
                                          expression: "gateInfor.gateName"
                                        }
                                      ],
                                      staticClass: "form-control input-sm",
                                      attrs: { type: "text", id: "gatename" },
                                      domProps: {
                                        value: _vm.gateInfor.gateName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "gateName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲート動作モード")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.gateInfor.isVisitor,
                                                  expression:
                                                    "gateInfor.isVisitor"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isVisitor",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(_vm.listIsVisitor, function(
                                              item
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.value,
                                                  domProps: {
                                                    value: item.value
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.text) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            })
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("NFCの有効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.gateInfor.isNFCValid,
                                                expression:
                                                  "gateInfor.isNFCValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.isNFCValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor.isNFCValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor.isNFCValid
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor.isNFCValid,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isNFCValid = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isNFCValid = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isNFCValid",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("テンキーの有効・無効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.isTenKeyValid,
                                                expression:
                                                  "gateInfor.isTenKeyValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor.isTenKeyValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor.isTenKeyValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor.isTenKeyValid
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor.isTenKeyValid,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isTenKeyValid = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isTenKeyValid = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isTenKeyValid",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲートパスワードの有効・無効")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor
                                                    .isGatePasswordValid,
                                                expression:
                                                  "gateInfor.isGatePasswordValid"
                                              }
                                            ],
                                            staticClass:
                                              "ace ace-switch ace-switch-4",
                                            attrs: {
                                              name: "switch-field-1",
                                              type: "checkbox",
                                              disabled: _vm.gateInfor.isVisitor
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.gateInfor
                                                  .isGatePasswordValid
                                              )
                                                ? _vm._i(
                                                    _vm.gateInfor
                                                      .isGatePasswordValid,
                                                    null
                                                  ) > -1
                                                : _vm.gateInfor
                                                    .isGatePasswordValid
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.gateInfor
                                                      .isGatePasswordValid,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.gateInfor.isGatePasswordValid = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.gateInfor.isGatePasswordValid = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "isGatePasswordValid",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", { staticClass: "lbl" })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲートパスワードの桁数")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.gateInfor
                                                      .gatePasswordLength,
                                                  expression:
                                                    "gateInfor.gatePasswordLength"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                disabled: _vm.getEditStatus()
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "gatePasswordLength",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(_vm.listPassLenght, function(
                                              item
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.value,
                                                  domProps: {
                                                    value: item.value
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(item.text) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            })
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ゲートパスワードのseed値")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c("span", {
                                            staticClass: "error_m",
                                            attrs: { id: "passwordseed_error" }
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor
                                                    .gatePasswordSeed,
                                                expression:
                                                  "gateInfor.gatePasswordSeed"
                                              }
                                            ],
                                            staticClass:
                                              "form-control input-sm",
                                            staticStyle: {
                                              "text-transform": "uppercase"
                                            },
                                            attrs: {
                                              type: "text",
                                              id: "pseed",
                                              disabled: _vm.getEditStatus()
                                            },
                                            domProps: {
                                              value:
                                                _vm.gateInfor.gatePasswordSeed
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.gateInfor,
                                                  "gatePasswordSeed",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-xs-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "profile-user-info profile-user-info-striped"
                            },
                            [
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("2段階認証の有効・無効")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.gateInfor.isTwoStepAuthValid,
                                          expression:
                                            "gateInfor.isTwoStepAuthValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox",
                                        disabled: _vm.gateInfor.isVisitor
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isTwoStepAuthValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isTwoStepAuthValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isTwoStepAuthValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a =
                                              _vm.gateInfor.isTwoStepAuthValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isTwoStepAuthValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isTwoStepAuthValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isTwoStepAuthValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("BLE出力設定")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _vm.gateInfor.makerCode === 2
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.bleIntensity,
                                                expression:
                                                  "gateInfor.bleIntensity"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.gateInfor,
                                                  "bleIntensity",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          _vm._l(
                                            _vm.listBleIntensityForWafer,
                                            function(item) {
                                              return _c(
                                                "option",
                                                {
                                                  key: item.value,
                                                  domProps: {
                                                    value: item.value
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(item.text) +
                                                      "\n                        "
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                        )
                                      : _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.gateInfor.bleIntensity,
                                                expression:
                                                  "gateInfor.bleIntensity"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.gateInfor,
                                                  "bleIntensity",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          _vm._l(_vm.listBleIntensity, function(
                                            item
                                          ) {
                                            return _c(
                                              "option",
                                              {
                                                key: item.value,
                                                domProps: { value: item.value }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          " +
                                                    _vm._s(item.text) +
                                                    "\n                        "
                                                )
                                              ]
                                            )
                                          })
                                        )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.checkShowHide(_vm.gateInfor.makerCode)
                                ? _c(
                                    "div",
                                    { staticClass: "profile-info-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-name" },
                                        [_vm._v("ブザー鳴動設定")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "profile-info-value" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.gateInfor.buzzerPattern,
                                                  expression:
                                                    "gateInfor.buzzerPattern"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              on: {
                                                change: function($event) {
                                                  var $$selectedVal = Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function(o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function(o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                  _vm.$set(
                                                    _vm.gateInfor,
                                                    "buzzerPattern",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                }
                                              }
                                            },
                                            _vm._l(
                                              _vm.listBuzzerPattern,
                                              function(item) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: item.value,
                                                    domProps: {
                                                      value: item.value
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(item.text) +
                                                        "\n                        "
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("備考.1")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "option1_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.option1,
                                          expression: "gateInfor.option1"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "option1",
                                        placeholder: "備考.1"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.option1
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "option1",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("備考.2")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("span", {
                                      staticClass: "error_m",
                                      attrs: { id: "option2_error" }
                                    }),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.option2,
                                          expression: "gateInfor.option2"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "option1",
                                        placeholder: "備考.2"
                                      },
                                      domProps: {
                                        value: _vm.gateInfor.option2
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.gateInfor,
                                            "option2",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "profile-info-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "profile-info-name" },
                                  [_vm._v("ステータス")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "profile-info-value" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.gateInfor.isValid,
                                          expression: "gateInfor.isValid"
                                        }
                                      ],
                                      staticClass:
                                        "ace ace-switch ace-switch-4",
                                      attrs: {
                                        name: "switch-field-1",
                                        type: "checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.gateInfor.isValid
                                        )
                                          ? _vm._i(
                                              _vm.gateInfor.isValid,
                                              null
                                            ) > -1
                                          : _vm.gateInfor.isValid
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.gateInfor.isValid,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.gateInfor.isValid = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.gateInfor.isValid = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.gateInfor,
                                              "isValid",
                                              $$c
                                            )
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "lbl" })
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 text-align-right" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn cancel_bottom",
                              attrs: { to: { name: "gates" } }
                            },
                            [
                              _vm._v(
                                "\n                  キャンセル\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info save_group_bottom",
                              attrs: { type: "button" },
                              on: { click: _vm.validateBeforeSubmit }
                            },
                            [
                              _vm._v(
                                "\n                  保存\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
      _vm._v(" "),
      _c("a", { attrs: { href: "#/" } }, [_vm._v("ダッシュボード")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("新規ゲート登録")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ade72e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ade72e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/gate/GateAdd.vue
// module id = null
// module chunks = 